<div class="maindv">
    <div class="row hdrBar">
        <div class="col-lg-12 col-md-12 mg-a">
            <h1>Vehicle Category</h1>
        </div>
    </div>
    <br>
    <div style="padding-left :14px">
        <div class="bgwhite" [style.background]="'#fff'">
            <app-data-grid id="grid"
                    class="gridHeight"
                    style="width:100%;    max-width: 100%!important;"
                    [dataSource]="ctgry_lst"
                    [legacyColumns]="columnDefs"
                    [searchPanel]="true"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="true"
                    [columnChooser]="false"
                    [allowExport]="true"
                    exportFileName="Vechile_lst"
                    [pageSize]="30"
                    [allowedPageSizes]="[10, 30, 50, 100]"
                    [showPageSizeSelector]="true"
                    [rowAlternationEnabled]="false"
                    [showBorders]="true"
                    [wordWrapEnabled]="true">


                    <app-grid-column [showInColumnChooser]="false" [visible]="true" [width]="100" caption="Edit"
                    cellTemplate="editTemplate"></app-grid-column>
                    <ng-template appGridCell="editTemplate" let-data="cell"><div>
                        <div class="tblEdtBtn" (click)="openSideBar('Edit',data.data)">
                            &nbsp;&nbsp;<span
                                style="font-size: 11px;text-transform:capitalize; font-weight: 500;color: green;">Edit</span>
                        </div>
                    </div></ng-template>

                    <app-grid-column [showInColumnChooser]="false" [visible]="true" [width]="100" caption="Delete"
                    cellTemplate="delTemplate"></app-grid-column>
                    <ng-template appGridCell="delTemplate" let-data="cell"><div>
                        <div class="tblEdtBtn" (click)="showDeleteConfirm(data.data)">
                            &nbsp;&nbsp;<span
                                style="font-size: 11px;text-transform:capitalize; font-weight: 500;color: red;">Delete</span>
                        </div>
                    </div></ng-template>
            </app-data-grid>
        </div>
    </div>
</div>
<nz-drawer [nzVisible]="ctgryForm" nzPlacement="right" [nzTitle]="sdBrHdr" (nzOnClose)="close()" [nzWidth]="500">
    <ng-container *nzDrawerContent>
        <div nz-row [nzGutter]="8">

            <div nz-col nzSpan="12">
                <nz-form-label nzRequired>Vehicle Category Name</nz-form-label>
                <nz-form-item>
                    <nz-form-control>
                        <input nz-input placeholder="Vehicle Category"  [(ngModel)]="ctgry_nm" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
                <nz-form-label>Vehicle Category code</nz-form-label>
                <nz-form-item>
                    <nz-form-control>
                        <input nz-input placeholder="Vehicle Category Code" [(ngModel)]="ctgry_cd"/>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div class="row" style="padding-left: 37%;padding-top: 11%;">
                <div style=" padding-right: 18px;">
                    <button nz-button nzType="primary" nzDanger>Cancel</button>
                </div>
                <div>
                    <button nz-button nzType="primary" style="padding-left: 24px;padding-right: 20px;"
                        (click)="addCategory()">Save</button>
                </div>
            </div>
        </div>
    </ng-container>
</nz-drawer>
